/**
 * @flow
 * @relayHash da643b863d12547b7276aeccfb9e8cb9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RemoveFavoriteInput = {|
  id: string,
  clientMutationId: string,
|};
export type FavoriteStarRemoveFavoriteMutationVariables = {|
  input: RemoveFavoriteInput
|};
export type FavoriteStarRemoveFavoriteMutationResponse = {|
  +removeFavorite: ?{|
    +customer: ?{|
      +favoriteIds: ?$ReadOnlyArray<string>
    |}
  |}
|};
export type FavoriteStarRemoveFavoriteMutation = {|
  variables: FavoriteStarRemoveFavoriteMutationVariables,
  response: FavoriteStarRemoveFavoriteMutationResponse,
|};
*/


/*
mutation FavoriteStarRemoveFavoriteMutation(
  $input: RemoveFavoriteInput!
) {
  removeFavorite(input: $input) {
    customer {
      favoriteIds
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemoveFavoriteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "favoriteIds",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FavoriteStarRemoveFavoriteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "removeFavorite",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveFavoritePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "customer",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FavoriteStarRemoveFavoriteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "removeFavorite",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveFavoritePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "customer",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "FavoriteStarRemoveFavoriteMutation",
    "id": null,
    "text": "mutation FavoriteStarRemoveFavoriteMutation(\n  $input: RemoveFavoriteInput!\n) {\n  removeFavorite(input: $input) {\n    customer {\n      favoriteIds\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c77557e3cc0fe101fc6cfb6da777d8b8';
module.exports = node;
